import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Code, Users, Award, ArrowRight } from "lucide-react";
import Projects from "../components/Projects/Projects"

const Home: React.FC = () => {
  const [heroRef, heroInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [servicesRef, servicesInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const services = [
    {
      icon: <Code size={40} />,
      title: "Software Development",
      description:
        "Delivering enterprise-grade solutions from concept to deployment. Full-stack development across web and mobile platforms, leveraging scalable cloud infrastructure and industry-leading technologies.",
    },
    {
      icon: <Users size={40} />,
      title: "Collaborative Process",
      description:
        "Partnering closely with stakeholders through transparent, iterative development cycles to deliver solutions that exceed expectations and drive business value.",
    },
    {
      icon: <Award size={40} />,
      title: "Quality Assurance",
      description:
        "Comprehensive testing protocols and quality standards ensuring reliable, secure, and production-ready applications that meet the highest professional benchmarks.",
    },
  ];

  const stats = [
    { number: "7+", label: "Projects Completed" },
    { number: "4+", label: "Happy Clients" },
    { number: "100%", label: "Satisfaction Rate" },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="hero" ref={heroRef} style={{ paddingTop: 0 }}>
        <div className="hero-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={heroInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <div className="hero-logo-section" style={{ marginBottom: 0 }}>
              <img src="/OWS.png" alt="OWS Logo" className="hero-logo" />
            </div>
            <h1>
              Welcome to <span className="gradient-text-white">OWS</span>
            </h1>
            <b style={{ marginBottom: 0, fontSize: "1.5rem" }}>
              Helping businesses establish their digital presence
            </b>
            <p>
              Crafting exceptional digital experiences with cutting-edge
              technology
            </p>
            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
                flexWrap: "wrap",
                marginTop: "2rem",
              }}
            >
              <Link to="/#projects" className="cta-button">
                View Our Work{" "}
                <ArrowRight size={20} style={{ marginLeft: "0.5rem" }} />
              </Link>
              <Link
                to="/booking"
                className="cta-button"
                style={{
                  background: "transparent",
                  border: "2px solid white",
                  color: "white",
                }}
              >
                Book Consultation
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Services Section */}
      <section
        className="section"
        style={{ background: "#ffffffff" }}
        ref={servicesRef}
      >
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={servicesInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h2 className="section-title">
              Our Services
            </h2>
            <div className="cards-grid">
              {services.map((service, index) => (
                <motion.div
                  key={index}
                  className="card"
                  initial={{ opacity: 0, y: 30 }}
                  animate={servicesInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <div style={{ color: "#9C02CB", marginBottom: "1rem" }}>
                    {service.icon}
                  </div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Projects Section */}
      <section
        id="projects"
        className="section"
        style={{ background: "#ffffffff" }}
        ref={servicesRef}
      >
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={servicesInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h2 className="section-title home-work-title">
              Our Work
            </h2>
            <div style={{ marginTop: "-0.5rem" }}>
              <Projects />
            </div>
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
    

      {/* CTA Section */}
      <section
        className="section"
        style={{
          background: "linear-gradient(135deg, #9C02CB 0%, #d946ef 100%)",
        }}
      >
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{ textAlign: "center", color: "white" }}
          >
            <h2 style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>
              Ready to Start Your Project?
            </h2>
            <p
              style={{ fontSize: "1.2rem", marginBottom: "2rem", opacity: 0.9 }}
            >
              Let's discuss your ideas and turn them into reality. Book a
              consultation today!
            </p>
            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Link to="/booking" className="cta-button">
                Book Consultation
              </Link>
              <Link
                to="/contact"
                className="cta-button"
                style={{
                  background: "transparent",
                  border: "2px solid white",
                  color: "white",
                }}
              >
                Contact Us
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;
